import React, { useState, useEffect, createContext } from "react";
import { MemoizedDetail } from "./Detail";
import { useLocation, useNavigate } from "react-router-dom";
import { MessageAlert, SpinLoading } from "../../components/Components";
import ContractorBillingService from "../../services/ContractorBillingService";
import { useTranslation } from "react-i18next";
import { EncryptStingMD5 } from "../../utils/AuthUtil";
import TokenGateway from "../../services/TokenGataway";
import appSettings from "../../utils/AppSetting";
import * as Constants from '../../utils/Constants';

const formDataContext = createContext();
const querystring = require("querystring");
const LoginPage = (props) => {

  const {
    setChiefNo
  } = props

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const contractorBillingService = ContractorBillingService();

  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isInValidUsername, setIsInValidUsername] = useState(false);
  const [isInValidPassword, setIsInValidPassword] = useState(false);
  const [isInValidEmail, setIsInValidEmail] = useState(false);
  const [isInvalidCode, setIsInValidCode] = useState(false);
  const [isInValidNewPassword, setIsInValidNewPassword] = useState(false);
  const [isInValidConfirmPassword, setIsInValidConfirmPassword] = useState(false);
  const [pageMode, setPageMode] = useState("login");
  const [resetStep, setResetStep] = useState("1");
  const [lang, setLang] = useState(i18n.language);
  const [refCode, setRefCode] = useState("");
  const [mode, setMode] = useState("");
  const tokenGateway = TokenGateway();

  const HandleChangeLanguage = (e, value) => {
    setLang(value);
    i18n.changeLanguage(value);
  }

  const { client_id, client_secret, scope, grant_type } =
  appSettings.services.Header;

  const model = {
    scope: scope,
    client_id: client_id,
    client_secret: client_secret,
    grant_type: grant_type,
  };

  const formData = querystring.stringify(model);
  const applNo = `${appSettings.services.application.appNo}`;
  const system = `${appSettings.services.application.system}`;
  const GetToken = async (model) => {
    try {
      let rs = await tokenGateway.GetToken(formData);

      if (rs?.access_token) {
        localStorage.setItem(
          "access_token",
          `${rs?.token_type} ${rs?.access_token}`
        );
        localStorage.setItem("consented_on", rs?.consented_on);
        localStorage.setItem("expires_in", rs?.expires_in);
        return rs;
      } else {
        throw(rs.statusMessage);
      }
    } catch (error) {
      MessageAlert.error({
        title: t("Warning"),
        message: error,
      });
    }
  };

  useEffect(() => {
    GetToken(model)
  
  }, []);

  const ResetPasswordClick = () => {
    setMode(Constants.MODE.RESET);
    setPageMode('reset');
    setIsInValidUsername(false);
    setIsInValidPassword(false);
    setUsername("");
    setPassword("");
  }

  const handleClickLogout = async () => {
    setChiefNo(null);
    localStorage.setItem("chiefNo", null);
  }

  const ValidateSignIn = async () => {
    try {
      if (username === "") setIsInValidUsername(true);
      if (password === "") setIsInValidPassword(true);
      if (username !== "" && password !== "") {
        setIsLoading(true);

        var loginRq = {
          username: username,
          password: EncryptStingMD5(password).toUpperCase(),
          isMode: "login"
        }

        var loginRs = await contractorBillingService.ValidationInformation(loginRq);

        if (loginRs.isSuccess) {
          setMode(Constants.MODE.LOGIN);
          setEmail(loginRs.result.email)
          setUsername(loginRs.result.username)

          await SendEmail({
            email: loginRs.result.email,
            username: loginRs.result.username
          });

          setResetStep("2");
          setPageMode('reset');
          
        } else {
          MessageAlert.warning({
            title: t('Warning'),
            message: loginRs.statusMessage,
          });
        }
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("Error SignIn : ", error);
    }
  }

  const SendEmail = async ({email: email_param, username: username_param } = {}) => {
    try {
      const emailToUse = email_param ?? email;
      const usernameToUse = username_param ?? username;
      if (usernameToUse === "") setIsInValidUsername(true);
      if (emailToUse === "") setIsInValidEmail(true);
      if (usernameToUse !== "" && emailToUse !== "") {
        setIsLoading(true);

        var validateEmailRq = {
          username: usernameToUse,
          email: emailToUse,
          isMode: "email"
        }

        var validateEmailRs = await contractorBillingService.ValidationInformation(validateEmailRq);

        if (validateEmailRs.isSuccess) {
          var sendEmailRq = {
            system: system,
            applNo: applNo,
            username: usernameToUse,
            email: emailToUse,
            languageEmail: lang?.toUpperCase() ?? 'TH'
          }
          var sendEmailRs = await contractorBillingService.SendEmail(sendEmailRq);

          setIsLoading(false);
          if (sendEmailRs.isSuccess) { 
            setRefCode(sendEmailRs?.result?.refCode)
            setResetStep("2");
          }
          else {
            MessageAlert.warning({
              title: t('Warning'),
             message: sendEmailRs.statusMessage,
            });
          }
        } else {
          MessageAlert.error({
            title: t('Warning'),
            message: validateEmailRs.statusMessage,
          });
        }

        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("Error SendEmail : ", error);
    }
  }

  const ValidateVerificationCode = async () => {
    try {
      if (code === "") setIsInValidCode(true);
      if (code !== "") {
        setIsLoading(true);

        var verifyCodeRq = {
          system: system,
          otp: code,
          refCode: refCode
        }

        var verifyCodeRs = await contractorBillingService.ValidateOTP(verifyCodeRq);

        if (verifyCodeRs.isSuccess) {
          if(mode == Constants.MODE.LOGIN){
            setChiefNo(username);
            localStorage.setItem("chiefNo", JSON.stringify(username));
            navigate('/Home');
          }else{
            setResetStep("3");
          }          
          setCode("");
        } else {
          MessageAlert.error({
            title: t('Warning'),
            message: verifyCodeRs.statusMessage,
          });
        }

        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("Error ValidateVerificationCode : ", error);
    }
  }

  const ChangePassword = async () => {
    try {
      if (newPassword === "") setIsInValidNewPassword(true);
      if (confirmPassword === "") setIsInValidConfirmPassword(true);

      if (newPassword !== "" && confirmPassword !== "") {
        if (newPassword === confirmPassword) {
          if(isStrongPassword(newPassword)){
            setIsLoading(true);

            var changePasswordRq = {
              username: username,
              newPassword: EncryptStingMD5(newPassword).toUpperCase(),
              email: email
            }

            var changePasswordRs = await contractorBillingService.ChangePassword(changePasswordRq);

            if (changePasswordRs.isSuccess) {
              await MessageAlert.success({
                title: t('Warning'),
                message: t('ChangePasswordSuccess'),
              });
              setResetStep("1");
              setPageMode('login');
              setNewPassword("");
              setConfirmPassword("");
              setEmail("");
              setUsername("");
            } else {
              MessageAlert.error({
                title: t('Warning'),
                message: changePasswordRs.statusMessage,
              });
            }

            setIsLoading(false);
          }else{
            MessageAlert.warning({
              title: t('Warning'),
              message: t('PasswordNotSecure'),
            });
          }
          
        } else {
          MessageAlert.warning({
            title: t('Warning'),
            message: t('ConfirmPasswordNotMatch'),
          });
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.log("Error ChangePassword : ", error);
    }
  }
  const isStrongPassword = (value) => {
    return /[A-Z]/.test(value) &&
          /[a-z]/.test(value) &&
          /[0-9]/.test(value) &&
          /[\W_]/.test(value) &&
          value.length >= 8;
  };
  const ResendVerificationCode = async () => {
    try {
      setIsLoading(true);

      var reSendEmailRq = {
        system: system,
        applNo: applNo,
        reqBy: username,
        email: email,
        languageEmail: lang.toUpperCase(),
        refCode: refCode
      }

      var reSendEmailRs = await contractorBillingService.ReSendEmail(reSendEmailRq);

      if (reSendEmailRs.isSuccess) {
        setRefCode(reSendEmailRs?.result?.refCode)
        MessageAlert.success({
          title: t('Warning'),
          message: t('SendVerificationCodeSuccess'),
        });
      } else {
        MessageAlert.warning({
          title: t('Warning'),
           message: reSendEmailRs.statusMessage,
        });
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("Error ResendVerificationCode", error)
    }
  }

  const BackLoginPage = () => {
    setPageMode('login');
    setIsInValidUsername(false);
    setIsInValidPassword(false);
    setUsername("");
    setPassword("");
    setEmail("");
  }

  useEffect(() => {
    handleClickLogout();
    //return () => {};
  }, []);

  return (
    <>
      <formDataContext.Provider
        value={{
          username, setUsername,
          password, setPassword,
          email, setEmail,
          code, setCode,
          newPassword, setNewPassword,
          confirmPassword, setConfirmPassword,
          isInValidUsername, setIsInValidUsername,
          isInValidPassword, setIsInValidPassword,
          isInValidEmail, setIsInValidEmail,
          isInvalidCode, setIsInValidCode,
          isInValidNewPassword, setIsInValidNewPassword,
          isInValidConfirmPassword, setIsInValidConfirmPassword,
          ValidateSignIn,
          SendEmail,
          ValidateVerificationCode,
          ChangePassword,
          HandleChangeLanguage,
          ResetPasswordClick,
          ResendVerificationCode,
          resetStep,
          mode,
          lang,
          BackLoginPage
        }}
      >
        <MemoizedDetail pageMode={pageMode} />
        {isLoading && <SpinLoading />}
      </formDataContext.Provider>
    </>
  );

};

export { formDataContext };
export default LoginPage